import { render, staticRenderFns } from "./PressClippingCarousel.vue?vue&type=template&id=10668e79&scoped=true&"
import script from "./PressClippingCarousel.vue?vue&type=script&lang=js&"
export * from "./PressClippingCarousel.vue?vue&type=script&lang=js&"
import style0 from "./PressClippingCarousel.vue?vue&type=style&index=0&id=10668e79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10668e79",
  null
  
)

export default component.exports